var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sortedBadges.length > 0)?_c('div',{staticClass:"flex flex-row flex-wrap gap-1 mt-1"},_vm._l((_vm.sortedBadges),function(badge){return _c('span',{key:badge.code,class:[
      'pickup-corporate__sh-badge',
      ("pickup-corporate__sh-badge--" + (badge.code.toLowerCase()))
    ],attrs:{"data-testid":("pickup-corporate__sh-badge-" + (badge.code.toLowerCase()) + "-" + _vm.shipmentId)}},[_vm._v(" "+_vm._s(badge.code)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }